import { useContext, useEffect } from 'react';

import styled from '@emotion/styled';

import useDirectorInformation from '../../../hooks/dashboard/kyc-compliance/useDirectorInformation';
import PreviewAblePdf from '../../PreviewAblePdf/PreviewAblePdf';
import TableSliderContentWrapper from '../TableAccessories/TableSliderContentWrapper';
import { TableContext } from '../TableContext';

interface ViewDirectorsInfoProps {
  data?: Record<string, any>;
}

const ViewDirectorsInfo: React.FC<ViewDirectorsInfoProps> = ({ data }) => {
  const { directorInfo, loading, directorData } = useDirectorInformation();
  const tableContext = useContext(TableContext);

  useEffect(() => {
    if (tableContext?.showTableSlide) {
      directorInfo(data?.id);
    }
    // eslint-disable-next-line
  }, [data?.id]);

  return (
    <TableSliderContentWrapper label="Directors' Information" loading={loading}>
      {/* section 1 */}
      <Section>
        <HeadTag>Director 1</HeadTag>
        <Cell>
          <CellLabel>Name</CellLabel>
          <div>{directorData?.directors[0]?.name ?? ''}</div>
        </Cell>
        <Cell>
          <CellLabel>Identification submitted</CellLabel>
          <div>{directorData?.directors[0]?.kycType ?? ''}</div>
        </Cell>
        <Cell>
          <CellLabel>Uploaded ID</CellLabel>
          <PreviewAblePdf
            docUrl={`${directorData?.directors[0]?.kycDocUrl ?? ''}`}
          />
        </Cell>
      </Section>

      {/* section 2 */}
      <Section>
        <HeadTag>Director 2</HeadTag>
        <Cell>
          <CellLabel>Name</CellLabel>
          <div>{directorData?.directors[1]?.name ?? ''}</div>
        </Cell>
        <Cell>
          <CellLabel>Identification submitted</CellLabel>
          <div>{directorData?.directors[1]?.kycType ?? ''}</div>
        </Cell>
        <Cell>
          <CellLabel>Uploaded ID</CellLabel>
          <PreviewAblePdf
            docUrl={`${directorData?.directors[1]?.kycDocUrl ?? ''}`}
          />
        </Cell>
      </Section>
    </TableSliderContentWrapper>
  );
};

export default ViewDirectorsInfo;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* border: 1px solid red; */
`;

const HeadTag = styled.div`
  display: flex;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  padding: 10px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  margin-bottom: -8px;
`;

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  padding: 12px;
  color: #2f3644;
  background-color: rgba(250, 250, 250, 0.8);
`;

const CellLabel = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.darkGrayText};
  /* border: 1px solid blue; */
`;
